import * as Styles from './_styles/nav-bar-link.styled'
import {useDimensions} from '../../../../contexts/dimensions/use-dimensions'
import {useRef, useState, type JSX} from 'react'
import {useOnClickOutside} from '../../../../hooks/useOnClickOutside'
import {DropdownMenuWrap} from './_styles/location-dropdown.styled'
import {Icon} from '../../../media/Icon/index'
import {LocationDropDownButtonStyle} from './location-dropdown-button/location-dropdown-button.styled'
import {NavBarLink} from './nav-bar-link'
import {useLocation} from 'react-router'
import useTypedSelector from '../../../../hooks/use-typed-selector'
import {isInternalUserSelector} from '../../../../store/state/current-user/selectors'
import {isUserAllowed} from '../../../../values/Role'
import {rolesSelector} from '../../../../store/state/roles/selectors'

export function SystemLink(): JSX.Element {
    const {width} = useDimensions()
    const [systemDropDown, setSystemDropDown] = useState(false)

    const isInternalUser = useTypedSelector(isInternalUserSelector)
    const userRoles = useTypedSelector(rolesSelector)
    const isUserRoleAllowed = isUserAllowed(userRoles, ['DEVELOPER', 'THREAT_ANALYST'])
    const isAllowed = isInternalUser && isUserRoleAllowed

    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-assignment
    const clickOutside = useRef(undefined) as any
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    useOnClickOutside(clickOutside, () => {
        setSystemDropDown(false)
    })

    const pathname = useLocation().pathname

    return (
        <Styles.NavigationLinkDiv
            id="navigation-system"
            width={width}
            activeLink={
                pathname.startsWith('/policy-management') ||
                pathname.startsWith('/vessel-management') ||
                pathname.startsWith('/user-management') ||
                pathname.startsWith('/engine-status') ||
                pathname.startsWith('/mona-engine-mode') ||
                pathname.startsWith('/self-monitoring-engine-status') ||
                pathname.startsWith('/email-recipients') ||
                pathname.startsWith('/swagger-links')
            }
            onClick={() => {
                setSystemDropDown(!systemDropDown)
            }}
            // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            ref={clickOutside}
        >
            System
            <DropdownMenuWrap>
                <LocationDropDownButtonStyle id="navigation-system-toggle">
                    <Icon
                        glyph={systemDropDown ? 'DropdownUp' : 'DropdownDown'}
                        height={15}
                        width={15}
                    />
                </LocationDropDownButtonStyle>
                {systemDropDown && (
                    <Styles.DropdownContentStyle width={width} wide>
                        {isUserAllowed(userRoles, [
                            'DEVELOPER',
                            'THREAT_ANALYST',
                            'CUSTOMER_ADMIN',
                        ]) && (
                            <NavBarLink
                                id="navigation-policy-management"
                                navLinkText="Policy Management"
                                path="/policy-management"
                            />
                        )}
                        {isUserAllowed(userRoles, [
                            'DEVELOPER',
                            'THREAT_ANALYST',
                            'CUSTOMER_ADMIN',
                        ]) && (
                            <NavBarLink
                                id="navigation-vessel-management"
                                navLinkText="Vessel Management"
                                path="/vessel-management"
                            />
                        )}
                        <NavBarLink
                            id="navigation-user-management"
                            navLinkText="User Management"
                            path="/user-management"
                        />
                        {isAllowed && (
                            <NavBarLink
                                id="navigation-engine-status"
                                path="/engine-status"
                                navLinkText="Engine Status"
                            />
                        )}
                        {isAllowed && (
                            <NavBarLink
                                id="navigation-mona-engine-mode"
                                path="/mona-engine-mode"
                                navLinkText="Mona Engine Mode"
                            />
                        )}
                        {isAllowed && (
                            <NavBarLink
                                id="navigation-self-monitoring-engine-status"
                                path="/self-monitoring-engine-status"
                                navLinkText="Self-monitioring Engine Status"
                            />
                        )}
                        {isAllowed && (
                            <NavBarLink
                                id="navigation-email-recipients-management"
                                path="/email-recipients"
                                navLinkText="Email Recipient Management"
                            />
                        )}
                        {isAllowed && (
                            <NavBarLink
                                id="navigation-swagger-links"
                                path="/swagger-links"
                                navLinkText="Swagger Links"
                            />
                        )}
                        {isAllowed && (
                            <NavBarLink
                                id="navigation-customer-packages"
                                path="/customer-packages"
                                navLinkText="Customer Packages"
                            />
                        )}
                    </Styles.DropdownContentStyle>
                )}
            </DropdownMenuWrap>
        </Styles.NavigationLinkDiv>
    )
}
